module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SidebarSlider Widget

(function (fox, $) {
	
	fox.registerWidget('Models_ClosestLiveshows', {

		configure: function (argument) {
			this.currentSlide = 0;

			this.registerOptions('', {
				slidePeriod: 12000,

				widgets: {
					api: {
						widget: 'Api',
						method: 'Portal.GetPublicLiveshowEvents',
						limit: 5,
						sendTimezone: true	
					},

					grid: {
						widget: 'Widget',
						autoRender: false,
						container: '.closest-liveshows',
						template: 'catalog_closest_liveshows',

						widgets: {
							list: {
								widget: 'List',
								autoRender: false,
								'tpl.row': 'catalog_closest_liveshows_row',
								container: '.closest-liveshows-list',

								'hooks.onAddedToDom': fox.bind(function () {
									this.insertCounters();
									this.initSlider();
									this.renderPager();
									this.showSlide(this.currentSlide);
								}, this)
							},
							pager: {
								widget: 'List',
								autoRender: false,
								'tpl.row': 'catalog_closest_liveshows_pager',
								container: '.closest-liveshows-pager'
							}
						}
					}
				},

				handleWom: {
					apiSuccess: {
						widget: '#api',
						event: ['success', 'error', 'failure'],
						callback: '_handleApiResponse'
					},

					slideShown: {
						widget: '@this',
						event: 'slide_shown',
						callback: 'markSlide'
					}
				},

				handleDom: {
					pagerClick: {
						targetWidget: '#grid #pager',
						target: '.slide',
						event: 'click',
						callback: '_changeSlide'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.callParent('init', arguments);
		},

		running: function () {
			this.api = this.rwom1('#api');
			this.grid = this.rwom1('#grid');
			this.list = this.grid.rwom1('#list');

			this.getClosestLiveshows();

			this.callParent('running', arguments);
		},

		getClosestLiveshows: function () {
			this.api.send({limit: this.wom1('#api').getOption('limit')});
		},

		_handleApiResponse: function (response, w, alias) {
			if (alias != 'success') {
				this.setListData(null);
				return;
			}

			fox.each(response.answer.response, function (item, i) {
				item._index = i;
			});

			this.setListData(response.answer.response);

			this.renderList();
		},

		setListData: function (data) {
			this.listData = data;
		},

		getListData: function (argument) {
			return this.listData;	
		},

		getListDataLength: function () {
			return fox.count(this.listData);
		},

		renderList: function () {
			var list = this.getListData();

			if (list) {
				this.list.setCollection(list, true);
				this.grid.render();

				return;
			};

			this.grid.removeFromDom();
		},

		insertCounters: function () {
			var blocks = this.list.dom('[data-liveshow-counter]');

			fox.each(blocks, function (elm, i) {
				var $elm = $(elm);
				var date = this.listData[i].startDate;
				var remTime = this._getRemainingtime(date);
				var format = "99:23:59:59";
				var interval = 1000 * 60;
				var obj = {
					0: 'Days',
					2: 'Hours',
					4: 'Minutes',
					6: 'Secs'
				};

				//console.log(remTime)

				if (remTime.split(':')[0] == 0) {
					format = '23:59:59';
					interval = 1000;
					obj = {
						0: 'hours',
						2: 'minutes',
						4: 'seconds'
					};
				}

				$elm.counter({
					initial: remTime,
			        direction: 'down',
			        format: format,
			        interval: interval,
			        stop: "00:00:00:00",
				});

				fox.each(obj, function (val, key) {
					$elm.find('.part' + key).append('<span class="label"> ' + val + '</span>');

					if (key == 6 && interval == 1000) {
						$elm.find('.separator5').addClass('show')
					}
				});

			}, this);
		},

		_getRemainingtime: function (date) {
			return fox.utils.getRemainingTime(date);
		},

		initSlider: function (argument) {
			this.stopSlide();
			this.startSlide();
		},

		startSlide: function (argument) {
			this.slidingId = window.setInterval(fox.bind(this._slide, this), this.getOption('slidePeriod'));
		},

		stopSlide: function () {
			if (this.slidingId) {
				window.clearInterval(this.slidingId);
			};
		},

		_slide: function () {
			// this.currentSlide++;
			this.setCurrentSlide(this.currentSlide + 1);

			if (this.currentSlide == this.getListDataLength()) {
				this.currentSlide = 0;
			};

			this.showSlide(this.currentSlide);
		},

		setCurrentSlide: function (num) {
			this.currentSlide = num;
		},

		showSlide: function (ind) {
			var items = this.grid.dom('.closest-liveshows-list .item');

			fox.each(items, function (item, i) {
				fox.dom.removeClass('active', item);

				if (ind == i) {
					window.setTimeout(fox.bind(function () {
						fox.dom.addClass('active', item);
						this.dispatchEvent('slide_shown', {ind: ind});	
					}, this), 500)
				};
			}, this);

			//$(block).css('transform', ['translateY', '(', -ind*47 , 'px',')'].join(''));
		},

		renderPager: function() {
			this.wom1('#grid #pager').setCollection(this.getListData(), true);
		},

		markSlide: function (data) {
			fox.each(this.wom1('#grid #pager').dom('.slide'), function (item, i) {
				fox.dom[(i == data.ind ? 'addClass' : 'removeClass')]('active', item);
			}, this);
		},

		_changeSlide: function (el) {
			var ind = window.parseInt(fox.dom.wrap(el).attr('slide-index'));
			this.stopSlide();
			this.setCurrentSlide(ind)
			this.showSlide(ind);
			this.startSlide();
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/models/closestLiveshows.js
// module id = 130
// module chunks = 0